export default {
  labelPosition: 'top',
  submitBtn: false,
  menuBtn: false,
  emptyBtn: false,
  column: []
};
